import { BaseService } from './base-service'
import { Observable } from 'rxjs'
import { CashAPIConstant } from '@/api/constant/cash'
import { FundMemberDetailRequest, FundMemberDetail } from '@/api/model/cash'
import { Page } from '@/api/model/base'

export class CashService extends BaseService {
    protected cashConstant: CashAPIConstant
    constructor() {
        super()
        this.cashConstant = new CashAPIConstant()
    }

    fundMemberDetailPage(data: FundMemberDetailRequest): Observable<Page<FundMemberDetail>> {
        return this.request(this.cashConstant.fundMemberDetailPage(data))
    }
}
